// extracted by mini-css-extract-plugin
export default {"wrapper":"purchases_wrapper__t5lbB","header":"purchases_header__W0CrK"};